import { Modal, message } from "ant-design-vue";
import store from "../store";

// 客户端静态提示信息，优先级低于服务器端提示信息
const messageData = {
    HTTP_REQUEST_ERROR: "请求处理超时！",
    HTTP_RESPONSE_ERROR: "请求处理异常！",

    HTTP_REQUEST_SUCCESS: "操作成功"
};

function replaceParams(args) {
    if (args.length > 0 && args[0]) {
        // 获取提示信息
        let content = store.state.messageData[args[0]] || messageData[args[0]] || args[0];
        for (let i = 1; i < args.length; i++) {
            content = content.replace(new RegExp(`\\$P${i}\\$`, "g"), args[i]);
        }
        return content;
    }
    return null;
}

export default {
    /**
     * 显示操作成功提示信息
     * @param args 提示信息和参数，第一个参数为提示信息号或提示信息，之后的参数为提示信息的替换参数
     * @returns {Promise<any>}
     */
    success(...args) {
        return new Promise((reslove, reject) => {
            let content = replaceParams(args);
            if (content) {
                message.success(content, 3).then(() => reslove());
            } else {
                reslove();
            }
        });
    },
    /**
     * 显示错误提示信息
     * @param args 提示信息和参数，第一个参数为提示信息号或提示信息，之后的参数为提示信息的替换参数
     * @returns {Promise<any>}
     */
    error(...args) {
        return new Promise((reslove, reject) => {
            let content = replaceParams(args);
            if (content) {
                Modal.error({
                    title: "错误",
                    destroyOnClose: true,
                    centered: true,
                    content,
                    onOk() {
                        reslove();
                    }
                });
            } else {
                reslove();
            }
        });
    },
    /**
     * 显示操作警告提示信息
     * @param args 提示信息和参数，第一个参数为提示信息号或提示信息，之后的参数为提示信息的替换参数
     * @returns {Promise<any>}
     */
    warn(...args) {
        return new Promise((reslove, reject) => {
            let content = replaceParams(args);
            if (content) {
                Modal.warning({
                    title: "提示",
                    destroyOnClose: true,
                    centered: true,
                    content,
                    onOk() {
                        reslove();
                    }
                });
            } else {
                reslove();
            }
        });
    },
    /**
     * 显示确认操作提示信息
     * @param args 提示信息和参数，第一个参数为提示信息号或提示信息，之后的参数为提示信息的替换参数
     * @returns {Promise<string>}，'ok'：确认，'cancel'：取消
     */
    confirm(...args) {
        return new Promise((reslove, reject) => {
            let content = replaceParams(args);
            if (content) {
                Modal.confirm({
                    title: "确认",
                    destroyOnClose: true,
                    centered: true,
                    content,
                    onOk() {
                        reslove("ok");
                    },
                    onCancel() {
                        reslove("cancel");
                    }
                });
            } else {
                reslove();
            }
        });
    }
};
